<template>
  <b-container>
    <b-row>
      <b-col sm="5" class="mx-auto mt-5">
        <ValidationObserver ref="loginForm" slim>
          <b-form @submit.prevent="send" class="clearfix mb-3" novalidate="novalidate">
            <b-card no-body>
              <b-card-header>
                <div class="text-primary d-flex justify-content-between align-items-center">
                  <h4>Interra Travel</h4>
                  <span><img src="@/assets/images/logo-interra-2.svg" alt="logo interra" class="img-fluid logo-img"></span>
                </div>
              </b-card-header>
              <b-card-body>
                <ValidationProvider
                    name="Nume Agentie"
                    :rules="{ required: true }"
                    v-slot="vContext"
                  >
                  <b-form-group label="Nume Agentie:" label-class="font-weight-bold pt-0" label-for="agency">
                    <b-input
                      type="text"
                      name="agency"
                      id="agency"
                      v-model="register.agency"
                      placeholder="nume agentie"
                      size="sm"
                      autofocus
                      :state="getValidationState(vContext)"
                      aria-describedby="agency"
                    />
                    <b-form-invalid-feedback id="agency">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider
                    name="Cod Unic Inregistrare"
                    :rules="{ required: true }"
                    v-slot="vContext"
                  >
                  <b-form-group label="CUI:" label-class="font-weight-bold pt-0" label-for="vat">
                    <b-input
                      type="text"
                      name="cui"
                      id="vat"
                      v-model="register.vat"
                      placeholder="cod unic inregistrare"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="cui"
                    />
                    <b-form-invalid-feedback id="cui">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider
                    name="Cod registru comertului"
                    :rules="{ required: true }"
                    v-slot="vContext"
                  >
                  <b-form-group label="Reg Com:" label-class="font-weight-bold pt-0" label-for="regCom">
                    <b-input
                      type="text"
                      name="regCom"
                      id="regCom"
                      v-model="register.regcom"
                      placeholder="nr inreg reg comertului"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="regCom"
                    />
                    <b-form-invalid-feedback id="regCom">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider
                  name="Email"
                  :rules="{required: true}"
                  v-slot="vContext"
                >
                  <b-form-group label="Email:" label-class="font-weight-bold pt-0" label-for="Adresa">
                    <b-input
                      type="email"
                      name="email"
                      id="email"
                      v-model="register.email"
                      placeholder="Adresa email"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="email"
                    />
                    <b-form-invalid-feedback id="email">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider
                  name="Telefon"
                  :rules="{required: true}"
                  v-slot="vContext"
                >
                  <b-form-group label="Telefon:" label-class="font-weight-bold pt-0" label-for="telefon">
                    <b-input
                      type="text"
                      name="telefon"
                      id="telefon"
                      v-model="register.phone"
                      placeholder="telefon"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="phone"
                    />
                    <b-form-invalid-feedback id="phone">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider
                  name="persoana contact"
                  :rules="{required: true}"
                  v-slot="vContext"
                >
                  <b-form-group label="Nume:" label-class="font-weight-bold pt-0" label-for="nume">
                    <b-input
                      type="text"
                      name="nume"
                      id="nume"
                      v-model="register.name"
                      placeholder="persoana de contact"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="agent_name"
                    />
                    <b-form-invalid-feedback id="agent_name">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider
                  name="persoana contact"
                  :rules="{required: true}"
                  v-slot="vContext"
                >
                  <b-form-group label="Adresa:" label-class="font-weight-bold pt-0" label-for="adresa">
                    <b-input
                      type="text"
                      name="adresa"
                      id="adresa"
                      v-model="register.address"
                      placeholder="adresa agentie"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="address"
                    />
                    <b-form-invalid-feedback id="address">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-card-body>
              <b-card-footer class="d-flex justify-content-between align-items-center">
                <small class="text-center py-1">
                  Pentru login
                  <router-link :to="{ name: 'Public/Login' }" class="link">click aici</router-link>
                </small>
                <b-button type="submit" variant="primary" class="float-right" size="sm">
                    <b>TRIMITE</b>
                  </b-button>
              </b-card-footer>
            </b-card>
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>
    <b-modal id="success" hide-header hide-footer v-model="modalSuccess" centered>
      <template v-if="subscribeSuccess">
        <div class="d-flex align-item-center justify-content-center">
          <div class="pt-4">
            <p class="d-flex align-item-center justify-content-center send-success">
              <b-iconstack font-scale="5" animation="throb">
                <b-icon stacked icon="check2" variant="success" scale="0.75"></b-icon>
                <b-icon stacked icon="circle" variant="success"></b-icon>
              </b-iconstack>
              <!-- <b-icon icon="check2" animation="throb" font-scale="8" class="text-success"></b-icon> -->
            </p>
            <h4 class="text-center">Datele au fost trimise cu succes!</h4>
          </div>
        </div>
        <!-- <hr> -->
        <p class="my-4 text-center">
          <router-link :to="{ name: 'Public/Login' }" class="btn btn-warning">
            <b>LOGIN</b>
          </router-link>
        </p>
      </template>
      <template v-else>
        <div class="d-flex align-item-center justify-content-center send-fail">
          <div class="pt-4">
            <p class="d-flex align-item-center justify-content-center">
              <b-icon icon="slash-circle" animation="throb" font-scale="8" class="text-danger"></b-icon>
            </p>
            <h5 class="text-center">Ne cerem scuze, a aparut o eroare in transmiterea datelor.<br/>Va rugam incercati din nou.</h5>
          </div>
        </div>
        <hr>
        <p class="my-4 text-center">
          <b-button @click="closeModal" variant="warning"> <b>INCHIDE</b> </b-button>
        </p>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import validation from 'b2b-common/mixins/validation'
import { register } from 'b2b-common/services/public'
import toast from 'b2b-common/mixins/toast'

export default {
  name: 'Subscribe',
  mixins: [validation, toast],
  data () {
    return {
      register: {
        agency: '',
        vat: '',
        regcom: '',
        email: '',
        phone: '',
        name: '',
        address: ''
      },
      modalSuccess: false,
      subscribeSuccess: true
    }
  },
  methods: {
    send () {
      this.$refs.loginForm.validate().then(success => {
        if (!success) {
          this.addToast({ title: 'Formular invalid', message: 'Va rugam completati toate campurile obligatorii!', variant: 'danger' })
        } else {
          register(this.register).then(res => {
            if (res !== 'OK') this.subscribeSuccess = false
            this.modalSuccess = true
          })
        }
      })
    },
    closeModal () {
      this.modalSuccess = false
    }
  }
}
</script>

<style scoped>
  .send-success{
    border: 2px solid rgba(0,128,0,.5);
    border-radius:5px;
    background-color: rgba(226,249,224,.35);
  }
  .send-fail{
    border: 2px solid rgba(185,0,0,.5);
    border-radius:5px;
    background-color: rgba(230,196,1964,.35);
    padding: 0 1rem 1rem;
  }
</style>
